import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "host"];
import React from 'react';
import { default as LegacyApi, LegacyApiEvent, LegacyApiEvents } from '@deezer/legacy-api';
import { createContext } from '@deezer/react-utils';

// This makes this package act as a react superset of '@deezer/legacy-api'.
import * as _legacyApiModule from '@deezer/legacy-api';
export { _legacyApiModule as legacyApiModule };
export { LegacyApi, LegacyApiEvent, LegacyApiEvents };
export const [ApiContextProvider, useApiContext, ApiContext] = createContext({
  name: 'Api'
});
let uniqueApiInstance;
const ApiProvider = _ref => {
  let {
      children,
      host
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!uniqueApiInstance) {
    uniqueApiInstance = new LegacyApi(host, options);
  }
  return /*#__PURE__*/React.createElement(ApiContextProvider, {
    value: uniqueApiInstance
  }, children);
};
export default ApiProvider;
export const useApiCall = () => {
  const ctxApiService = useApiContext();
  return ctxApiService.call.bind(ctxApiService);
};
//# sourceMappingURL=index.js.map